// ─── Shared style constants ───────────────────────────────────────────────────

export const SECTION_HEADING = {
  fontFamily: '"Azeret Mono", monospace',
  fontSize: "clamp(16px, 2.5vw, 16px)",
  fontWeight: 600,
  color: "#1a1a1a",
  margin: "0 0 2.5rem",
  letterSpacing: "-0.02em",
};

export const SECTION_WRAP = {
  maxWidth: "920px",
  margin: "0 auto",
  padding: "5rem 2rem",
};
